import { Box, Grid, styled } from '@mui/material';

import { DynamicTooltipChip } from '../dynamicTooltipChip/DynamicTooltipChip';

export const StyledGrid = styled(Grid)`
  margin: 0 7px;
  max-width: calc(100% - 201px - 14px); // LeftContainer width and its margin
`;

export const ChipContainer = styled(Box)`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const RowSection = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;
